import React, { useEffect, useState } from "react";
import Button from "../../extra/Button";
import { connect, useDispatch, useSelector } from "react-redux";
import Table from "../../extra/Table";
import { getShowcase, deleteShowcase } from "../../store/showcase/showcase.action";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import ShowcaseDialog from "./ShowcaseDialog";
import { warning } from "../../../util/Alert";
import Pagination from "../../extra/Pagination";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { colors } from "../../../util/SkeletonColor";
import Iconb from "../../extra/Iconb";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteIcon from "@mui/icons-material/Delete";

const Showcase = (props) => {
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const { showcase } = useSelector((state) => state.showcase);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getShowcase());
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(showcase);
  }, [showcase]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const handleDelete = (id) => {
    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          dispatch(deleteShowcase(id));
        }
      })
      .catch((err) => console.log(err));
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => (
        <span className="text-white fw-normal">
          {page * rowsPerPage + index + 1}
        </span>
      ),
    },
    {
      Header: "Title",
      body: "title",
      Cell: ({ row }) => (
        <p className="mb-0 text-white fw-normal">{row.title}</p>
      ),
    },
    {
      Header: "Categories",
      body: "categories",
      Cell: ({ row }) => (
        <p className="mb-0 text-white fw-normal">
          {row.categories?.map((c) => c.name).join(", ") || "-"}
        </p>
      ),
    },
    {
      Header: "Source",
      body: "productSource",
      Cell: ({ row }) => (
        <p className="mb-0 text-white fw-normal">{row.productSource}</p>
      ),
    },
    {
      Header: "Order",
      body: "sortOrder",
      Cell: ({ row }) => (
        <p className="mb-0 text-white fw-normal">{row.sortOrder}</p>
      ),
    },
    {
      Header: "Status",
      body: "isActive",
      Cell: ({ row }) => (
        <span
          className={`badge ${row.isActive ? "bg-success" : "bg-danger"}`}
          style={{ padding: "6px 12px" }}
        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      Header: "Edit",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<CreateOutlinedIcon sx={{ color: "#737272" }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",
          }}
          isImage={true}
          onClick={() => {
            dispatch({
              type: OPEN_DIALOGUE,
              payload: { data: row, type: "Showcase" },
            });
          }}
        />
      ),
    },
    {
      Header: "Delete",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter killbtn userBtn fs-5`}
          btnIcon={<DeleteIcon sx={{ color: "#FF4C51" }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",
            padding: "0px",
          }}
          isImage={true}
          isDeleted={true}
          onClick={() => handleDelete(row?._id)}
        />
      ),
    },
  ];

  return (
    <>
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Showcase Management</div>
          <div className="sellerMain">
            <div className="tableMain mt-2 categoryTable">
              <div className="sellerHeader primeHeader">
                <div className="row">
                  <div className="col-12">
                    <Button
                      newClass={`whiteFont`}
                      btnColor={`btnBlackPrime `}
                      btnIcon={`fa-solid fa-plus `}
                      btnName={`Add`}
                      onClick={() => {
                        dispatch({
                          type: OPEN_DIALOGUE,
                          payload: { type: "Showcase" },
                        });
                      }}
                      style={{
                        borderRadius: "5px",
                        padding: "8px 32px",
                        background: "#F0C420",
                      }}
                    />
                    {dialogue && dialogueType === "Showcase" && (
                      <ShowcaseDialog />
                    )}
                  </div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                PerPage={rowsPerPage}
                Page={page}
                type={"client"}
              />
              <Pagination
                component="div"
                count={showcase?.length}
                serverPage={page}
                type={"client"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={showcase?.length}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{ display: "flex", justifyContent: "start" }}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getShowcase, deleteShowcase })(Showcase);
